import { Link } from "react-router-dom";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {  Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useSettings } from "../../context/SettingsContext";
import { assetUrl } from "utils/api";
import {t} from "../../context/translations";
import SectionHeader from "./SectionHeader";

const SlideSwiperView = ({
  data = [],
  loading = false,
  slidesPerView = 6,
  title = "",
  linkKey = "catalogue_id", // key for Link path
  imageKey = "image_path", // key for img src
  textKey = "title", // key for text
}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { theme } = useSettings();
  const isDark = theme === "dark";
  const slides = data.length <= slidesPerView ? [...data] : data;

  // Skeleton slide
  const SlideSkeleton = () => (
    <div className="flex flex-col items-center mb-4">
      {/* Avatar shimmer */}
      <div
        className={`w-[80px] h-[80px] md:w-[110px] md:h-[110px] rounded-full relative overflow-hidden mt-4 mb-2
    ${isDark ? "bg-slate-800" : "bg-gray-300"}`}
      >
        <div
          className={`absolute inset-0 animate-shimmer
      ${
        isDark
          ? "bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800"
          : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
      }`}
        />
      </div>

      {/* Text shimmer */}
      <div
        className={`mt-3 h-4 w-16 rounded relative overflow-hidden
    ${isDark ? "bg-slate-700" : "bg-gray-300"}`}
      >
        <div
          className={`absolute inset-0 animate-shimmer
      ${
        isDark
          ? "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700"
          : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
      }`}
        />
      </div>
    </div>
  );

  return (
    <div className="relative md:max-w-7xl mx-auto  sm:px-4 2xl:px-0 lg:px-8  md:pb-4 pb-0 ">
      <div className="px-4 rounded">
        {title && (
            <SectionHeader title={title} />
          // <div className="flex items-center justify-between my-2 ">
          //   <div className="">
          //     <h2 className="text-xl md:text-2xl font-semibold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
          //       {title}
          //     </h2>
          //     <div className="w-12 h-[2px] bg-gradient-to-r from-indigo-600 to-pink-500 mt-1 rounded-full"></div>
          //   </div>
          // </div>
        )}

        {loading ? (
          <Swiper
            slidesPerView={slidesPerView}
            spaceBetween={16}
          >
            {Array.from({ length: slidesPerView }).map((_, i) => (
              <SwiperSlide key={i}>
                <SlideSkeleton />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : data.length === 0 ? (
          <div className="text-center py-10 my-5">
            <p className="font-semibold">No items available</p>
          </div>
        ) : (
          <div className="pt-2">
            <Swiper
              modules={[ Navigation]}
              loop
              speed={800}
              navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              spaceBetween={16}
              breakpoints={{
                320: { slidesPerView: 4 },
                640: { slidesPerView: 4 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView },
              }}
              className="pb-10"
            >
              {slides.map((item, index) => (
                <SwiperSlide key={`${item.id}-${index}`}>
                  <Link to={`/category/${item[linkKey]}`}>
                    <div className="flex flex-col items-center mb-4 ">
                      {/*<div className="w-[80px] h-[80px] md:w-[130px] md:h-[130px] bg-gray-100 rounded-full overflow-hidden flex items-center justify-center">*/}
                        <div className="w-[60px] h-[60px] md:w-[110px] md:h-[110px] rounded-full overflow-hidden border ">
                          <img
                              src={assetUrl(item[imageKey])}
                              alt={item[textKey]}
                              loading={index < 4 ? "eager" : "lazy"}
                              decoding="async"
                              className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                              draggable={false}
                          />
                        </div>
                      {/*</div>*/}
                      <p className="sm:text-sm text-xs font-bold text-center pt-2">
                        {item[textKey]}
                      </p>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}

              {/* Navigation buttons */}
              <button
                ref={prevRef}
                className="absolute top-1/2 left-0 z-10 -translate-y-1/2 text-darkBgColor hover:bg-white/50 bg-white w-9 h-9 rounded-full flex items-center justify-center shadow border"
              >
                ❮
              </button>
              <button
                ref={nextRef}
                className="absolute top-1/2 right-0 z-10 -translate-y-1/2 text-darkBgColor hover:bg-white/50 bg-white w-9 h-9 rounded-full flex items-center justify-center shadow border"
              >
                ❯
              </button>
            </Swiper>
          </div>
        )}
      </div>
    </div>
  );
};

export default SlideSwiperView;
